const alphabeticalSortASC = (a, b) =>
  a.toUpperCase().localeCompare(b.toUpperCase())

export default alphabeticalSortASC



// WEBPACK FOOTER //
// ./src/utils/alphabeticalSortASC.js